module.exports = __webpack_public_path__ + "img/payment-details.9a7a762f.jpg";